import { KoAPI } from "packages";
import { configs } from 'configuration';
const version = configs().API_VERSION;
export const OrdersAPI = {
  getCount(data, workspaceId) {
    return KoAPI.get(`/api/${version}/taskplanner/ticket/priority/statistics`, { data });
  },



  createCategory(data) {
    return KoAPI.post(`/api/${version}/order/category/add`, {data});
  },

  createProduct(categroyId,subCategroyId, workspaceId,data) {
    return KoAPI.post(`/api/${version}/order/${categroyId}/${subCategroyId}/product/add`, {
      data: { ...data }, header: {
        "workspace": workspaceId
      }});
  },

  getCategory() {
    return KoAPI.get(`/api/${version}/order/category/fetch`);
  },
  createChildCategory(categoryId,subId,data){
    return KoAPI.post(`/api/${version}/order/category/${categoryId}/sub/${subId}/child`,{data});
  },
  getChildCategory(categoryId,subId){
    return KoAPI.get(`/api/${version}/order/category/${categoryId}/sub/${subId}/child/fetch`);
  },
  createSubCategory(id,data){
    return KoAPI.post(`/api/${version}/order/category/sub/${id}`,{data});
  },
  getSubCategory(id){
    return KoAPI.get(`/api/${version}/order/category/${id}/sub/fetch`);
  }


};